export default {
  components: {
    workflowSelector: {
      placeholder: '请选择工作流',
      fetchFailed: '获取工作流列表失败',
    },
    workflowVersionPanel: {
      title: '历史版本',
      filter: {
        all: '全部',
        onlyMy: '仅我提交',
        onlyPublished: '只显示已发布配置',
      },
      loading: '加载中...',
      deprecated: '已废弃',
      placeholder: '请输入版本名称',
      actions: {
        publish: '发布',
        viewConfig: '查看配置',
        loadToCurrent: '加载到当前',
        deprecate: '废弃',
        delete: '删除',
      },
      empty: '暂无版本数据',
      deprecateModal: {
        title: '废弃版本',
        alert: '废弃版本后，执行标识将无法绑定到此版本，且无法恢复。',
        reason: '废弃原因',
        reasonPlaceholder: '请输入废弃此版本的原因',
      },
      message: {
        fetchFailed: '加载版本列表失败',
        loadSuccess: '成功加载版本 {version}',
        loadFailed: '导入版本失败',
        deprecateConfirm: '请输入废弃原因',
        deprecateFailed: '废弃版本失败',
      },
      deprecateDisableHint: '该版本被{protocols}执行标识绑定，无法废弃',
    },
    workflowEntryInput: {
      label: '工作流执行参数',
      mode: {
        keyValue: '键值对模式',
        json: 'JSON模式',
      },
      importExample: '导入示例配置',
      exampleConfig: '示例配置',
      placeholder: '请选择你要导入的示例配置',
      message: {
        jsonMustBeObject: 'JSON数据必须是一个对象才能转换为键值对模式',
        jsonFormatError: 'JSON格式错误，无法转换为键值对模式',
        importSuccess: '示例配置导入成功',
        fetchFailed: '加载示例配置失败',
      },
    },
    variableInput: {
      triggerHint: '输入 $ 可选择前置节点变量',
    },
    workflowToSchemaModal: {
      title: '从工作流导入数据结构',
      selectWorkflow: '选择工作流',
      entryNodeInfo: '入口节点信息',
      nodeName: '节点名称:',
      nodeType: '节点类型:',
      outputVars: '输出变量:',
      varCount: '{count} 个变量',
      preview: '输出变量预览',
      childrenCount: '包含 {count} 个子变量',
      importVars: '导入变量',
      message: {
        noEntry: '该工作流没有入口节点或入口节点不存在',
        defaultEntryName: '入口节点',
        noOutputVars: '该工作流的入口节点没有定义输出变量',
        fetchDetailFailed: '获取工作流详情失败',
        validate: '请选择工作流并确保有输出变量',
        importSuccess: '成功导入 {count} 个变量',
        importFailed: '导入变量失败',
      },
    },
    conversationItem: {
      noContent: '无对话内容',
      noOptions: '无对话选项',
    },
    modal: {
      deleteConfirm: {
        title: '确认删除',
        okText: '删除',
        cancelText: '取消',
      },
      resourceDelete: {
        title: '确认删除',
        okText: '删除',
        cancelText: '取消',
        confirmContent: '确定要删除 {name} 吗？',
        inputLabel: '请输入 {name} 来确认删除：',
        placeholder: '请输入名称确认删除',
        autoFill: '一键填充',
        deleteFailed: '删除操作失败',
      },
      versionConflict: {
        title: '版本冲突',
        notice: {
          title: '有人提交了新版本',
          desc: '检测到工作流已被其他人更新，请选择如何处理你的草稿版本。',
        },
        selectionTitle: '请选择一个版本覆盖当前草稿：',
        options: {
          saveDraft: {
            title: '我的草稿',
            desc: '将你的草稿保存为新版本',
            tag: '当前编辑',
            lastEdited: '最后编辑：',
            editor: '编辑人：',
          },
          latestVersion: {
            title: '最新版本',
            desc: '加载最新版本到草稿，你可以在最新版本上编辑后保存',
            tag: '已发布',
            updateTime: '更新时间：',
            updater: '更新人：',
            viewDetail: '查看详情',
          },
        },
        actions: {
          confirm: '确认选择',
          cancel: '取消',
        },
        unknownTime: '未知时间',
        unknownUser: '未知',
      },
    },
    backendSelect: {
      label: '后台服务',
      currentService: '当前服务',
    },
    columnsShowSelector: {
      title: '列展示',
      columnName: '列名',
    },
    cardList: {
      updatedAt: '更新于',
      empty: '暂无数据',
    },
    catalogDrawer: {
      title: '快捷修改目录',
      tips: {
        title: '操作提示：',
        dragToModify: '1. 拖拽工作流到目录中可修改目录',
        dragToWorkflow: '2. 拖拽到工作流节点时，目录设置为目标工作流的目录',
        emptyDelete: '3. 空白目录会自动删除',
      },
      addCatalog: {
        placeholder: '输入新目录名，支持多级如a/b/c',
        button: '新增目录',
      },
      tree: {
        emptyDropArea: '拖拽到此处可移到根目录',
      },
      renameModal: {
        title: '重命名目录',
        alert: {
          title: '操作提示：',
          content: '此操作将会影响所有子目录和子工作流',
        },
        label: '新目录名',
        placeholder: '请输入新目录名',
        required: '请输入新目录名',
      },
      messages: {
        pathNotFound: '未找到目录路径',
        enterName: '请输入新目录名',
        renameSuccess: '目录重命名成功',
        updateFailed: '部分工作流目录更新失败',
        addSuccess: '目录添加成功',
        exists: '目录已存在',
        dragWorkflowOnly: '只能拖拽工作流到目录中',
        moveToRootSuccess: '已移到根目录',
        moveToRootFailed: '移动到根目录失败',
        updateSuccess: '目录更新成功',
        updateCatalogFailed: '更新目录失败',
        dragToCatalogOnly: '只能将工作流拖拽到目录中',
        dragToRootOnly: '只能拖拽工作流到根目录',
      },
    },
    mysqlFormControl: {
      unsupportedDefault: '该类型不支持配置默认值',
      placeholder: {
        integer: '请输入整数',
        decimal: '请输入小数', // FLOAT, DOUBLE
        number: '请输入数字', // DOUBLE fallback
        text: '请输入文本',
        json: '请输入 JSON 数据',
        datetime: '请选择日期时间',
        date: '请选择日期',
        time: '请选择时间',
        default: '该类型字段不支持编辑',
      },
      switch: {
        yes: '是',
        no: '否',
      },
    },
    backendUpdateModal: {
      title: '后台服务更新',
      label: '后台服务',
      placeholder: '请选择你要更新的后台服务',
      rule: '请选择服务端口',
      success: '更新{port}服务成功，请前往对应服务查看',
    },
    bindHistoryDrawer: {
      title: '{protocol}执行标识绑定历史记录',
      columns: {
        description: '描述',
        workflow: '绑定工作流',
        editor: '创建人',
        createdAt: '创建时间',
      },
      noDescription: '暂无描述',
    },
    deleteImpactModal: {
      title: '删除节点影响分析',
      okText: {
        autoFix: '智能修复并删除',
        confirm: '确认删除',
      },
      loading: '分析中...',
      sections: {
        affected: '受影响的节点',
        brokenEdges: '会断开的连接',
        orphaned: '可能成为孤立节点',
        autoFixTitle: '可以智能修复',
        autoFixContent: '系统可以自动重连边并更新变量引用到上游节点',
        noImpact: '删除此节点不会影响其他节点',
        reconnectTo: '可自动重连到: {node}',
      },
      fallback: '确定要删除此节点吗？删除后相关引用变量将会自动解除',
    },
    createKnowledgeModal: {
      title: {
        edit: '编辑知识库',
        create: '创建知识库',
      },
      okText: {
        saving: '保存中...',
        save: '保存',
      },
      form: {
        name: '知识库名称',
        namePlaceholder: '请输入',
        desc: '知识库描述',
        descPlaceholder: '请输入',
        embeddingModel: '向量模型',
        selectPlaceholder: '请选择',
        vectorDbType: '向量库类型',
        metadata: '知识库元信息',
      },
      table: {
        key: '元信息键',
        desc: '描述',
        default: '默认值',
        required: '是否必填',
        add: '添加字段',
      },
      rules: {
        name: '请输入知识库名称',
        nameLength: '知识库名称长度必须为2-30个字符',
        desc: '请输入知识库描述',
        keyEmpty: '第 {row} 行的元信息键不能为空',
        keyDuplicate: '存在重复的元信息键：{names}',
      },
    },
    createWorkflowModal: {
      title: {
        edit: '编辑工作流',
        copy: '复制工作流',
        create: '创建工作流',
      },
      okText: {
        saving: '保存中...',
        save: '保存',
      },
      form: {
        name: '工作流名称',
        namePlaceholder: '请输入',
        desc: '工作流描述',
        descPlaceholder: '请输入',
        tags: '工作流标签',
        tagsPlaceholder: '请选择标签',
        catalog: '归属目录',
        catalogPlaceholder: '请选择已有目录，或者输入新目录，点击保存后生效',
        recordLog: '执行记录开关',
        errorBehavior: '错误处理',
        errorTooltip:
          '停止执行：当工作流某一节点发生异常时会中断流程；继续执行：当工作流某一节点发生异常时，工作流仍然会执行剩余待执行流程；剩余节点执行结果很大程度取决于该节点配置是否受异常节点影响。',
        selectPlaceholder: '请选择',
      },
      errorOptions: {
        stop: '停止执行',
        continue: '继续执行',
      },
      rules: {
        name: '请输入工作流名称',
        nameLength: '工作流名称长度必须为2-30个字符',
        desc: '请输入工作流描述',
      },
      copySuffix: '-副本',
    },
    createWorkspaceModal: {
      title: '创建工作区',
      okText: {
        creating: '创建中...',
        create: '创建',
      },
      form: {
        name: '工作区名称',
        namePlaceholder: '请输入工作区名称',
        description: '工作区描述',
        descPlaceholder: '请输入工作区描述（可选）',
      },
      rules: {
        name: '请输入工作区名称',
      },
      success: '工作区创建成功',
      error: '创建工作区失败',
    },
    emailVerification: {
      title: '邮箱验证',
      email: '邮箱',
      emailPlaceholder: '请输入工作空间所有者邮箱',
      emailRequired: '请输入邮箱',
      emailInvalid: '请输入有效的邮箱地址',
      code: '验证码',
      codePlaceholder: '请输入6位验证码',
      codeRequired: '请输入验证码',
      codeInvalid: '验证码为6位数字',
      sendCode: '发送验证码',
      codeSent: '验证码已发送到您的邮箱',
      sendCodeFail: '发送验证码失败，请重试',
      verifySuccess: '验证成功',
      verifyFail: '验证失败，请检查验证码',
    },
    executeWorkflowPanel: {
      title: '测试工作流',
      saveBeforeTest: '测试之前请先保存工作流',
      runningAlert: {
        title: '正在运行工作流',
        content1: '您可以安全地关闭此窗口，并在完成后在',
        link1: '测试任务',
        content2: '中查看状态和结果。要实时监控执行情况，请点击',
        link2: '追踪',
        content3: '。',
      },
      tabs: {
        input: '输入',
        details: '详情',
        trace: '追踪',
      },
      aiGenerate: {
        tooltip: {
          noParams: '当前工作流没有输入参数',
          generate: 'AI智能生成测试数据',
        },
        button: 'AI生成',
        popover: {
          title: '描述测试场景（可选）',
          placeholder: '例如：测试中文问答、测试异常输入...',
          generateButton: '生成测试数据',
        },
      },
      importExample: '导入示例',
      noInputTip: '没有输入变量',
      noRunData: '暂无运行数据',
      viewLog: '查看日志',
      totalTokens: '总 Tokens',
      testCase: {
        select: '选择测试集',
        add: '新增测试集',
        modalTitle: '新增测试集',
        name: '测试集名称',
        description: '测试集描述',
        inputVariables: '输入变量',
        saveWithRun: '将此次运行保存为测试集',
        nameRequired: '请输入测试集名称',
        createSuccess: '测试集已创建',
        createFailed: '创建测试集失败',
      },
      subscription: {
        idle: '未订阅',
        connecting: '订阅中',
        connected: '已订阅',
        error: '订阅异常',
      },
      testButton: {
        testing: '测试中...',
        start: '开始测试',
      },
      triggerTestRun: {
        startNodeSelect: '选择开始节点',
        startingTitle: 'Trigger Test Run 启动中',
        starting: '正在启动 Trigger Test Run 会话，请稍候...',
        listeningTitle: 'Trigger 正在监听中',
        webhookListening:
          '已进入监听状态，等待事件发生；现在可以使用 Test Run Webhook URL 接收事件，或将其作为回调地址进行实时调试。',
        scheduleListening:
          '已进入监听状态，等待事件发生；你可以等待当前 Schedule Trigger 的下一次定时调度。',
        triggeredTitle: 'Trigger 已收到事件',
        triggered: '已收到 Trigger 事件，正在准备执行工作流...',
        nextRunAt: '下一次计划执行时间：{time}',
        stoppedTitle: 'Trigger Test Run 已中止',
        stopped: '本次 Trigger Test Run 已中止。',
        errorTitle: 'Trigger Test Run 异常',
        stop: '停止监听',
        stopSuccess: '已停止 Trigger Test Run',
        stopFailed: '停止 Trigger Test Run 失败',
        startFailed: '启动 Trigger Test Run 失败',
        triggerUnavailable:
          '当前 Trigger 尚未生成可用的服务信息，请先保存或发布工作流',
      },
      messages: {
        noParams: '没有需要填写的参数',
        generateSuccess: '测试数据已生成',
        generateFailed: 'AI生成失败',
        wsNotConnected: 'WebSocket 未连接,请稍后重试',
        wsParseFailed: 'WebSocket 消息解析失败',
      },
      traceMedia: {
        title: '媒体输出',
        preview: '预览',
        download: '下载',
        previewUnavailable: '预览不可用',
        unknownFile: '媒体文件',
        kind: {
          image: '图片',
          video: '视频',
          audio: '音频',
          file: '文件',
        },
      },
    },
    fieldRenderer: {
      inputPlaceholder: '请输入{field}',
      itemPlaceholder: '第 {index} 项',
      itemLabel: '第 {index} 项：',
      addItem: '添加项',
      addObject: '添加对象',
      addKeyValue: '添加键值对',
      arrayObjectTitle: '{name} {index}',
      objectTitle: '对象 {index}',
      objectJsonPlaceholder: '请输入 JSON 格式的对象',
      keyPlaceholder: '键',
      valuePlaceholder: '值',
      jsonFormatError: 'JSON 格式错误',
    },
    executeResults: {
      viewLog: '查看日志',
      input: '输入',
      output: '输出',
    },
    documentViewer: {
      type: {
        word: 'Word 文档',
        pdf: 'PDF 文档',
        excel: 'Excel 表格',
        pptx: 'PowerPoint 演示文稿',
      },
      download: '下载文档',
      downloadFile: '下载文件',
      noPreviewNote: '该格式暂不支持在线预览，请下载后查看',
      empty: '无法显示文档内容',
    },
    fullscreenInputPanel: {
      code: '代码',
      systemPrompt: '系统提示词',
      userPrompt: '用户提示词',
      prompt: '用户提示词',
      exceptionHandle: '异常处理',
    },
    debugSettings: {
      title: '调试设置',
      workflowHttpBaseUrl: 'Workflow HTTP Base URL',
      workflowHttpBaseUrlPlaceholder: '例如: http://localhost:8080',
      workflowCopilotWsPort: 'Workflow Copilot WS Port',
      workflowCopilotWsPortPlaceholder: '例如: 8081',
      workflowExecutionWsPort: 'Workflow Execution WS Port',
      workflowExecutionWsPortPlaceholder: '例如: 8082',
      saveSuccess: '调试设置已保存',
      saveFailed: '保存失败',
    },
  },
  feedbackBot: {
    wishlist: {
      tab: '心愿单',
      title: '许个愿望 ✨',
      contentLabel: '你想要什么功能？',
      contentPlaceholder: '描述你希望看到的功能或改进...',
      contactLabel: '联系方式（可选）',
      contactPlaceholder: '邮箱，方便我们跟进',
      submit: '提交愿望',
      success: '愿望已收到，我们会认真考虑！✨',
    },
    feedback: {
      tab: '问题反馈',
      title: '反馈问题 🐛',
      typeLabel: '问题类型',
      typePlaceholder: '请选择问题类型',
      types: {
        bug: '功能 Bug',
        ui: '界面 / 显示',
        performance: '性能问题',
        other: '其他',
      },
      contentLabel: '描述问题',
      contentPlaceholder: '复现步骤、预期行为与实际行为...',
      contactLabel: '联系方式（可选）',
      contactPlaceholder: '邮箱，方便我们跟进',
      submit: '提交反馈',
      success: '感谢你的反馈！我们会尽快处理 🙌',
    },
    required: '此项为必填',
  },
};
